export class SourceCodeDto 
{
    id = 0;
    sourceCode = '';
    description: string | null= null;
    glCode: string | null = null;
    statusCode = '';
    isDefault = true;
}
